import { MouseEvent } from 'react';
import { Paragraph, PriceBadge, Image } from '@app/shared/ui/atoms/Common';
import { PriceType } from '@app/shared/types/common';
import { cn, telegramVibrate } from '@app/shared/utils/common';
import { giftImage } from '@/app/assets';

interface StoneProps {
  nodeLevel: number;
  image: string;
  isPurchased?: boolean;
  title?: string;
  description?: string;
  price?: number;
  cardColor?: string;
  className?: string;
  priceSize?: 'small' | 'large';
  titleClassName?: string;
  imageClassName?: string;
  onGiftClick?: (nodeLevel: number) => void;
}

export function Stone({
  nodeLevel,
  className = '',
  price,
  isPurchased = false,
  cardColor,
  title,
  description,
  image,
  priceSize,
  titleClassName,
  imageClassName,
  onGiftClick,
}: StoneProps) {
  const handleGiftClick = (e: MouseEvent<HTMLImageElement>, nodeLevel: number) => {
    e.stopPropagation();
    telegramVibrate();
    onGiftClick?.(nodeLevel);
  };

  return (
    <div
      className={cn(
        className,
        title && 'relative flex flex-col items-center rounded-lg p-[4.5px_3px_8px]',
        cardColor
      )}
    >
      {!isPurchased && price && (
        <PriceBadge type={PriceType.COOKIE} price={price} size={priceSize} />
      )}
      {isPurchased && onGiftClick && (
        <Image
          src={giftImage}
          className={cn('w-[46px] absolute left-0 top-[115px] z-20 cursor-pointer')}
          onClick={(e) => {
            handleGiftClick(e, nodeLevel);
          }}
        />
      )}
      <img
        src={image}
        alt={title ?? 'diamond icon'}
        className={cn('w-[51px] h-auto', imageClassName)}
      />
      {title && (
        <Paragraph
          size="xs"
          className={cn('my-auto flex items-center justify-center text-center', titleClassName)}
          variant="secondary"
        >
          {title}
        </Paragraph>
      )}
      {description && (
        <Paragraph variant="white" className="mt-5 whitespace-pre-line">
          {description}
        </Paragraph>
      )}
    </div>
  );
}
